import { filterVisibleHosts } from "./filterVisibleHosts.js";

export const filterVisibleCharacters = ({
  canViewOtherHidden,
  characters,
  hostEmployeeId,
}) =>
  characters?.reduce((acc, character) => {
    const { host } = character;
    const hostsToFilter = filterVisibleHosts({
      canViewOtherHidden,
      hostEmployeeId,
      hosts: [host],
    });

    return hostsToFilter.length ? [...acc, character] : acc;
  }, []);
